/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Ce } from './Ce';

class CertExamApplyPaper extends Ce {
    constructor() {
        super();
        this.baseUrl += '/certExamApplyPaper';
    }

    certExamApplyPaperList({ certExamExamId, certExamApplyId } = {}) {
        return super.get('/certExamApplyPaperList', {
            certExamExamId,
            certExamApplyId,
        });
    }

    getCertExamApplyPaperDetail({ certExamApplyPaperId }) {
        return super.get('/getCertExamApplyPaperDetail', { certExamApplyPaperId });
    }
}

export default new CertExamApplyPaper();
export { CertExamApplyPaper };
